import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-icon-collapse",
  "use": "app-icon-icon-collapse-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-icon-collapse\"><g fill=\"none\" fill-rule=\"evenodd\"><rect stroke=\"#4D84FF\" stroke-width=\"2\" x=\"1\" y=\"1\" width=\"14\" height=\"14\" rx=\"2\" /><path fill=\"#4D84FF\" fill-rule=\"nonzero\" d=\"M5 7h6v2H5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol